"use client";

import { Link } from "@/components/CustomLink";
import { Button } from "@/components/ui/button";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

interface SiteMapPaginationProps {
  currentPage: number;
  totalPages: number;
}

export default function SiteMapPagination({ currentPage, totalPages }: SiteMapPaginationProps) {
  const hasPrevious = currentPage > 1;
  const hasNext = currentPage < totalPages;

  return (
    <div className="flex justify-center items-center gap-4 py-8">
      {hasPrevious ? (
        <Link href={`/site-haritasi/${currentPage - 1}`}>
          <Button variant="outline" className="flex items-center gap-2">
            <ChevronLeftIcon className="size-4" />
            Önceki Sayfa
          </Button>
        </Link>
      ) : (
        <Button variant="outline" disabled className="flex items-center gap-2">
          <ChevronLeftIcon className="size-4" />
          Önceki Sayfa
        </Button>
      )}

      <span className="text-sm text-gray-600">
        Sayfa {currentPage} / {totalPages}
      </span>

      {hasNext ? (
        <Link href={`/site-haritasi/${currentPage + 1}`}>
          <Button variant="outline" className="flex items-center gap-2">
            Sonraki Sayfa
            <ChevronRightIcon className="size-4" />
          </Button>
        </Link>
      ) : (
        <Button variant="outline" disabled className="flex items-center gap-2">
          Sonraki Sayfa
          <ChevronRightIcon className="size-4" />
        </Button>
      )}
    </div>
  );
}
